import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import IntegrationTests from '../components/admin/IntegrationTests';
import styles from './styles/AdminPage.module.css';

interface Product {
    idProductos: number;
    NombresProductos: string;
}

interface Local {
    locales_id: number;
    nombre_local: string;
}

const ITPage: React.FC = () => {
    const { isAuthenticated, user } = useAuth();
    const [products, setProducts] = useState<Product[]>([]);
    const [locales, setLocales] = useState<Local[]>([]);
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const prodRes = await fetch(`${API_URL}/productos`);
                const prodData = await prodRes.json();
                if (Array.isArray(prodData)) setProducts(prodData);

                const locRes = await fetch(`${API_URL}/locales`);
                const locData = await locRes.json();
                if (Array.isArray(locData)) setLocales(locData);
            } catch (err) {
                console.error("Error fetching data for IT page:", err);
            }
        };
        fetchData();
    }, [API_URL]);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#48111d' }}>Panel de Control Técnico (IT)</h2>
                <p style={{ color: '#666' }}>Esta es una página oculta para pruebas de integración y diagnóstico del sistema de stock.</p>
            </div>

            <IntegrationTests
                products={products}
                locales={locales}
                user={user}
                apiUrl={API_URL}
            />
        </div>
    );
};

export default ITPage;
